// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Projects {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
        padding: 20px;

        font-family: "Montserrat";
}

.Projects.clickHandler{
        border-color: red;

}
.Projects_container {
        border: 1px solid #e4e4e4;

        display: flex;
        /* flex-direction: column; */
        flex-grow: 1;
        background-color: #ffffff;

        padding-bottom: 0;
        overflow: hidden;
}

.Projects_left {
        flex-grow: 1;
        padding: 20px;
        overflow-y: auto;
}

.Projects_label1 {
        font-size: 20px;
        margin-bottom: 20px;
}

.Projects_createAndEditRow {
        display: flex;
        overflow: hidden;
}

.Projects_imageContainer {
        display: flex;
}

.Projects_fieldsContainer {
        display: flex;
        width: 1000px;
        overflow: hidden;
        margin-bottom: 20px;

        font-family: "Montserrat";
        font-size: 14px;

        align-items: center;
}

.Projects_fieldsCol {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
}

.Projects_fieldRow {
        display: flex;
        height: 35px;
        width: 100%;
        margin-bottom: 10px;
}

.Projects_fieldRow.buttonsRow {
        margin-top: 45px;
        justify-content: right;
}

.Projects_fieldRow_label {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: right;
}

.Projects_fieldRow_input {
        border: 1px solid #e4e4e4;
        width: 50%;
        margin-left: 15px;
}

.Projects_fieldRow_button {
        height: 35px;
        width: 80px;
        background-color: #1f5f01;
        color: #fff;
        font-weight: 500;

        cursor: pointer;
}

.Projects_fieldRow_button.cancel {
        border: 1px solid #e4e4e4;
        margin-left: 15px;
        background-color: #ffffff;
        color: #000;
}

.Projects_label2 {
        font-size: 20px;
        /* margin-top: 30px; */
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;
}

.Projects_totalUsers {
        font-size: 14px;
        font-weight: 600;
}

.Projects_projectsFlex {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
}

.Projects_right {
        width: 520px;
        padding: 20px;

        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        overflow-y: auto;

        border-left: 1px solid #E4E4E4;
}

.Projects_right_cols {
        height: 100%;
        display: flex;
}

/* .Projects_right_col1 {
} */

.Projects_right_col2 {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
}

.Projects_fieldsRow {
        display: flex;
        margin-bottom: 20px;
}

.Projects_img {
        height: 100px;
        width: 100px;
        border: 1px solid #e4e4e4;

        display: flex;
        align-items: center;
        justify-content: center;
}

.Projects_projectLogo {
        width: 50px;
}

.Projects_fieldBox {
        width: 50%;
}

.Projects_fieldBox.right {
        margin-left: 20px;
}

.Projects_fieldLabel {
        font-size: 14px;
        font-weight: 500;
}
.Projects_fieldLabel.value {
        font-weight: 600;
        margin-top: 5px;
        max-width: 215px;
        overflow: hidden;
        text-overflow: ellipsis;
}

.Projects_fieldEntry {
        border: 1px solid #e4e4e4;
        height: 40px;
        margin-top: 5px;
        width: 100%;
        padding: 0 0px;
        font-size: 14px;
        font-weight: 600;
}

.Projects_fieldEntry.date {
        width: 50%;
}
.Projects_fieldEntry.date.right {
        margin-left: 5px;
}
.Projects_fieldEntry.rag {
        padding-left: 0;
}

.Projects_fieldEntry > input[type=file] {
        width: 100%;
        height: 100%;
}

.Projects_fieldEntry > input[type=file]::file-selector-button {
        margin-right: 20px;
        height: 100%;
        border: none;
        border-right: 1px solid #e4e4e4;
        padding: 0 10px;
        cursor: pointer;
}

.Projects_dateRange {
        display: flex;
        width: 100%;
        padding: 0px 20px;
}

.Projects_managers {
        margin-bottom: 20px;
}

.Projects_addTeamMember {
        display: flex;
        justify-content: flex-end;
}

.Projects_addTeamMemberButton {
        height: 30px;
        width: 100px;
}

.Projects_membersBox {
        border: 1px solid #e4e4e4;
        margin-top: 10px;
        height: 100px;
        overflow-y: auto;
}

.Projects_membersRow {
        display: flex;
        height: 40px;
        align-items: center;
}
.Projects_membersRow:hover {
        background-color: #f3f3f3ec;
}
.Projects_member {
        font-size: 14px;
        padding-left: 15px;
}
.Projects_member.selected {
        font-weight: 600;
}

.Projects_right_button {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
}

.Projects_buttonGroup {
        display: flex;
}

.Projects_rightButton {
        margin-left: 10px;
}

.Projects_team.managers {
        margin-bottom: 20px;
}

.Projects_delete_button {
        margin-left: 10px;
}
.icons{
        height: 15px;
        margin-left: 8px;
      }

      .enhanced-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 30px;
        background: linear-gradient(45deg, #4CAF50, #81C784); /* Gradient color */
        color: white;
        font-size: 16px;
        font-weight: 600;
        border: none;
        border-radius: 12px;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        outline: none;
        position: relative;
      }
      
      .enhanced-button::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.1);
        opacity: 0;
        transition: opacity 0.3s ease;
      }
      
      .enhanced-button:hover::before {
        opacity: 1; /* Adds a subtle light overlay on hover */
      }
      
      .enhanced-button:hover {
        transform: translateY(-8px); /* 3D lift effect */
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3); /* Deeper shadow on hover */
        background: linear-gradient(45deg, #66BB6A, #388E3C); /* Gradient transition */
      }
      
      .enhanced-icon {
        margin-left: 10px;
        width: 22px;
        height: 22px;
        transition: transform 0.3s ease, filter 0.3s ease;
      }
      
      .enhanced-button:hover .enhanced-icon {
        transform: rotate(20deg) scale(1.2); /* More pronounced rotate and scale effect */
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.3)); /* Adds shadow to the icon */
      }
      `, "",{"version":3,"sources":["webpack://./src/screens/Projects/Projects.css"],"names":[],"mappings":"AAAA;QACQ,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;QAChB,aAAa;;QAEb,yBAAyB;AACjC;;AAEA;QACQ,iBAAiB;;AAEzB;AACA;QACQ,yBAAyB;;QAEzB,aAAa;QACb,4BAA4B;QAC5B,YAAY;QACZ,yBAAyB;;QAEzB,iBAAiB;QACjB,gBAAgB;AACxB;;AAEA;QACQ,YAAY;QACZ,aAAa;QACb,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,mBAAmB;AAC3B;;AAEA;QACQ,aAAa;QACb,gBAAgB;AACxB;;AAEA;QACQ,aAAa;AACrB;;AAEA;QACQ,aAAa;QACb,aAAa;QACb,gBAAgB;QAChB,mBAAmB;;QAEnB,yBAAyB;QACzB,eAAe;;QAEf,mBAAmB;AAC3B;;AAEA;QACQ,aAAa;QACb,YAAY;QACZ,sBAAsB;AAC9B;;AAEA;QACQ,aAAa;QACb,YAAY;QACZ,WAAW;QACX,mBAAmB;AAC3B;;AAEA;QACQ,gBAAgB;QAChB,sBAAsB;AAC9B;;AAEA;QACQ,UAAU;QACV,aAAa;QACb,mBAAmB;QACnB,sBAAsB;AAC9B;;AAEA;QACQ,yBAAyB;QACzB,UAAU;QACV,iBAAiB;AACzB;;AAEA;QACQ,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,WAAW;QACX,gBAAgB;;QAEhB,eAAe;AACvB;;AAEA;QACQ,yBAAyB;QACzB,iBAAiB;QACjB,yBAAyB;QACzB,WAAW;AACnB;;AAEA;QACQ,eAAe;QACf,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,gBAAgB;QAChB,aAAa;QACb,eAAe;AACvB;;AAEA;QACQ,YAAY;QACZ,aAAa;;QAEb,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,gBAAgB;;QAEhB,8BAA8B;AACtC;;AAEA;QACQ,YAAY;QACZ,aAAa;AACrB;;AAEA;GACG;;AAEH;QACQ,aAAa;QACb,YAAY;QACZ,sBAAsB;AAC9B;;AAEA;QACQ,aAAa;QACb,mBAAmB;AAC3B;;AAEA;QACQ,aAAa;QACb,YAAY;QACZ,yBAAyB;;QAEzB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;AAC/B;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,UAAU;AAClB;;AAEA;QACQ,iBAAiB;AACzB;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;AACA;QACQ,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;AAC/B;;AAEA;QACQ,yBAAyB;QACzB,YAAY;QACZ,eAAe;QACf,WAAW;QACX,cAAc;QACd,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,UAAU;AAClB;AACA;QACQ,gBAAgB;AACxB;AACA;QACQ,eAAe;AACvB;;AAEA;QACQ,WAAW;QACX,YAAY;AACpB;;AAEA;QACQ,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,+BAA+B;QAC/B,eAAe;QACf,eAAe;AACvB;;AAEA;QACQ,aAAa;QACb,WAAW;QACX,iBAAiB;AACzB;;AAEA;QACQ,mBAAmB;AAC3B;;AAEA;QACQ,aAAa;QACb,yBAAyB;AACjC;;AAEA;QACQ,YAAY;QACZ,YAAY;AACpB;;AAEA;QACQ,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QACb,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,YAAY;QACZ,mBAAmB;AAC3B;AACA;QACQ,2BAA2B;AACnC;AACA;QACQ,eAAe;QACf,kBAAkB;AAC1B;AACA;QACQ,gBAAgB;AACxB;;AAEA;QACQ,gBAAgB;QAChB,aAAa;QACb,yBAAyB;AACjC;;AAEA;QACQ,aAAa;AACrB;;AAEA;QACQ,iBAAiB;AACzB;;AAEA;QACQ,mBAAmB;AAC3B;;AAEA;QACQ,iBAAiB;AACzB;AACA;QACQ,YAAY;QACZ,gBAAgB;MAClB;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,oDAAoD,EAAE,mBAAmB;QACzE,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,2EAA2E;QAC3E,yCAAyC;QACzC,aAAa;QACb,kBAAkB;MACpB;;MAEA;QACE,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,oCAAoC;QACpC,UAAU;QACV,6BAA6B;MAC/B;;MAEA;QACE,UAAU,EAAE,yCAAyC;MACvD;;MAEA;QACE,2BAA2B,EAAE,mBAAmB;QAChD,0CAA0C,EAAE,2BAA2B;QACvE,oDAAoD,EAAE,wBAAwB;MAChF;;MAEA;QACE,iBAAiB;QACjB,WAAW;QACX,YAAY;QACZ,iDAAiD;MACnD;;MAEA;QACE,mCAAmC,EAAE,4CAA4C;QACjF,mDAAmD,EAAE,4BAA4B;MACnF","sourcesContent":[".Projects {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n        overflow: hidden;\n        padding: 20px;\n\n        font-family: \"Montserrat\";\n}\n\n.Projects.clickHandler{\n        border-color: red;\n\n}\n.Projects_container {\n        border: 1px solid #e4e4e4;\n\n        display: flex;\n        /* flex-direction: column; */\n        flex-grow: 1;\n        background-color: #ffffff;\n\n        padding-bottom: 0;\n        overflow: hidden;\n}\n\n.Projects_left {\n        flex-grow: 1;\n        padding: 20px;\n        overflow-y: auto;\n}\n\n.Projects_label1 {\n        font-size: 20px;\n        margin-bottom: 20px;\n}\n\n.Projects_createAndEditRow {\n        display: flex;\n        overflow: hidden;\n}\n\n.Projects_imageContainer {\n        display: flex;\n}\n\n.Projects_fieldsContainer {\n        display: flex;\n        width: 1000px;\n        overflow: hidden;\n        margin-bottom: 20px;\n\n        font-family: \"Montserrat\";\n        font-size: 14px;\n\n        align-items: center;\n}\n\n.Projects_fieldsCol {\n        display: flex;\n        flex-grow: 1;\n        flex-direction: column;\n}\n\n.Projects_fieldRow {\n        display: flex;\n        height: 35px;\n        width: 100%;\n        margin-bottom: 10px;\n}\n\n.Projects_fieldRow.buttonsRow {\n        margin-top: 45px;\n        justify-content: right;\n}\n\n.Projects_fieldRow_label {\n        width: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: right;\n}\n\n.Projects_fieldRow_input {\n        border: 1px solid #e4e4e4;\n        width: 50%;\n        margin-left: 15px;\n}\n\n.Projects_fieldRow_button {\n        height: 35px;\n        width: 80px;\n        background-color: #1f5f01;\n        color: #fff;\n        font-weight: 500;\n\n        cursor: pointer;\n}\n\n.Projects_fieldRow_button.cancel {\n        border: 1px solid #e4e4e4;\n        margin-left: 15px;\n        background-color: #ffffff;\n        color: #000;\n}\n\n.Projects_label2 {\n        font-size: 20px;\n        /* margin-top: 30px; */\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        font-weight: 600;\n}\n\n.Projects_totalUsers {\n        font-size: 14px;\n        font-weight: 600;\n}\n\n.Projects_projectsFlex {\n        margin-top: 20px;\n        display: flex;\n        flex-wrap: wrap;\n}\n\n.Projects_right {\n        width: 520px;\n        padding: 20px;\n\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n        overflow-y: auto;\n\n        border-left: 1px solid #E4E4E4;\n}\n\n.Projects_right_cols {\n        height: 100%;\n        display: flex;\n}\n\n/* .Projects_right_col1 {\n} */\n\n.Projects_right_col2 {\n        display: flex;\n        flex-grow: 1;\n        flex-direction: column;\n}\n\n.Projects_fieldsRow {\n        display: flex;\n        margin-bottom: 20px;\n}\n\n.Projects_img {\n        height: 100px;\n        width: 100px;\n        border: 1px solid #e4e4e4;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n}\n\n.Projects_projectLogo {\n        width: 50px;\n}\n\n.Projects_fieldBox {\n        width: 50%;\n}\n\n.Projects_fieldBox.right {\n        margin-left: 20px;\n}\n\n.Projects_fieldLabel {\n        font-size: 14px;\n        font-weight: 500;\n}\n.Projects_fieldLabel.value {\n        font-weight: 600;\n        margin-top: 5px;\n        max-width: 215px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n}\n\n.Projects_fieldEntry {\n        border: 1px solid #e4e4e4;\n        height: 40px;\n        margin-top: 5px;\n        width: 100%;\n        padding: 0 0px;\n        font-size: 14px;\n        font-weight: 600;\n}\n\n.Projects_fieldEntry.date {\n        width: 50%;\n}\n.Projects_fieldEntry.date.right {\n        margin-left: 5px;\n}\n.Projects_fieldEntry.rag {\n        padding-left: 0;\n}\n\n.Projects_fieldEntry > input[type=file] {\n        width: 100%;\n        height: 100%;\n}\n\n.Projects_fieldEntry > input[type=file]::file-selector-button {\n        margin-right: 20px;\n        height: 100%;\n        border: none;\n        border-right: 1px solid #e4e4e4;\n        padding: 0 10px;\n        cursor: pointer;\n}\n\n.Projects_dateRange {\n        display: flex;\n        width: 100%;\n        padding: 0px 20px;\n}\n\n.Projects_managers {\n        margin-bottom: 20px;\n}\n\n.Projects_addTeamMember {\n        display: flex;\n        justify-content: flex-end;\n}\n\n.Projects_addTeamMemberButton {\n        height: 30px;\n        width: 100px;\n}\n\n.Projects_membersBox {\n        border: 1px solid #e4e4e4;\n        margin-top: 10px;\n        height: 100px;\n        overflow-y: auto;\n}\n\n.Projects_membersRow {\n        display: flex;\n        height: 40px;\n        align-items: center;\n}\n.Projects_membersRow:hover {\n        background-color: #f3f3f3ec;\n}\n.Projects_member {\n        font-size: 14px;\n        padding-left: 15px;\n}\n.Projects_member.selected {\n        font-weight: 600;\n}\n\n.Projects_right_button {\n        margin-top: 20px;\n        display: flex;\n        justify-content: flex-end;\n}\n\n.Projects_buttonGroup {\n        display: flex;\n}\n\n.Projects_rightButton {\n        margin-left: 10px;\n}\n\n.Projects_team.managers {\n        margin-bottom: 20px;\n}\n\n.Projects_delete_button {\n        margin-left: 10px;\n}\n.icons{\n        height: 15px;\n        margin-left: 8px;\n      }\n\n      .enhanced-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 12px 30px;\n        background: linear-gradient(45deg, #4CAF50, #81C784); /* Gradient color */\n        color: white;\n        font-size: 16px;\n        font-weight: 600;\n        border: none;\n        border-radius: 12px;\n        cursor: pointer;\n        transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;\n        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n        outline: none;\n        position: relative;\n      }\n      \n      .enhanced-button::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        background: rgba(255, 255, 255, 0.1);\n        opacity: 0;\n        transition: opacity 0.3s ease;\n      }\n      \n      .enhanced-button:hover::before {\n        opacity: 1; /* Adds a subtle light overlay on hover */\n      }\n      \n      .enhanced-button:hover {\n        transform: translateY(-8px); /* 3D lift effect */\n        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3); /* Deeper shadow on hover */\n        background: linear-gradient(45deg, #66BB6A, #388E3C); /* Gradient transition */\n      }\n      \n      .enhanced-icon {\n        margin-left: 10px;\n        width: 22px;\n        height: 22px;\n        transition: transform 0.3s ease, filter 0.3s ease;\n      }\n      \n      .enhanced-button:hover .enhanced-icon {\n        transform: rotate(20deg) scale(1.2); /* More pronounced rotate and scale effect */\n        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.3)); /* Adds shadow to the icon */\n      }\n      "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
